import { Node } from 'tiptap'

export default class Youtube extends Node {

    get name() {
        return 'youtube'
    }

    get schema() {
        return {
            attrs: {
                'data-id': {
                    default: null,
                },
                'data-type': {
                    default: 'youtube'
                }
            },
            inline: true,
            group: 'inline',
            selectable: true,
            draggable: true,
            parseDOM: [{
                tag: 'span.youtube',
                getAttrs: dom => ({
                    'data-id': dom.getAttribute('data-id'),
                    'data-type': dom.getAttribute('data-type'),
                }),
            }],
            toDOM: node => ['span', {
                'class': 'youtube',
                'data-id': node.attrs['data-id'],
                'data-type': node.attrs['data-type'],
                'style': 'background-image: url('+'youtubeimg' + node.attrs['data-id'] + '/mqdefault.jpg'+');',
                'clickprevent': '$emit(show,\''+node.attrs['data-id']+'\')',
            }],
        }
    }

    get view() {
        return {
            props: ['node', 'updateAttrs', 'view'],
            computed: {
                src: {
                    get() {
                        return this.node.attrs['data-id']
                    },
                    set(src) {
                        this.updateAttrs({
                            src,
                        })
                    },
                },
                videoType: {
                    get() {
                        return this.node.attrs['data-type']
                    },
                    set(videoType) {
                        this.updateAttrs({
                            videoType,
                        })
                    },
                },
                id(){
                    return this.node.attrs['data-id'];
                },
                preview() {
                    return '//img.youtube.com/vi/' + this.id + '/mqdefault.jpg'
                },
            },
            methods: {
                showFullScreen(id) {
                    document.dispatchEvent(new CustomEvent('showvideo', { detail: id }));
                },
            },
            template: `<span class="youtube" @click="showFullScreen(id)" :data-type="videoType" :style="{'background-image': 'url('+preview+')'}">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>`,
        }
    }

    commands({ type }) {
        return {
            youtube: attrs => (state, dispatch) => {
                const { selection } = state
                const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos
                const node = type.create(attrs)
                const transaction = state.tr.insert(position, node)
                dispatch(transaction)
            },
        }
    }

}